// extracted by mini-css-extract-plugin
export default {"languageSwitcher":"LanguageSwitcher_languageSwitcher__1Ib8K"};